<template>
    <div class="lni-c-box--content lni-u-mhauto lni-u-mv3">
        <lni-html-element
            id="job-plan_intro"
            class="lni-u-mb3 lni-u-reading-width--max"
            :htmlString="content.intro"
        />
        <lni-janitorial-job-plan id="job-plan" />
        <lni-html-element
            id="job-plan_disclaimer"
            class="lni-u-mt3 lni-u-type--bold lni-u-type--xxs lni-u-line-height--tight"
            :htmlString="content.disclaimer"
        />
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'LniJobPlanPage',
    computed: {
        ...mapGetters({
            content: 'appState/content',
        }),
    },
}; </script>